import { FC, useEffect, useState } from 'react';
import { Button, Col, Divider, Input, Row, Typography } from 'antd';
import { TbArrowRight, TbTextSize, TbUsersMinus } from 'react-icons/tb';
import { toast } from '@/shared/components/toasts/PlatformToast';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { BaseSkeleton } from '@/shared/components/skeletons';
import { useTeamStore, useWorkspaceStore } from '@/stores';
import { Team, TeamVisibilityType } from '@/types';

import DeleteTeamModal from './DeleteTeamModal';

interface SettingsProps {
    team: Team;
}

const Settings: FC<SettingsProps> = ({ team }): JSX.Element => {
    const [loading, setLoading] = useState(true);
    // const [collapsed, setCollapsed] = useState(false);

    const [input, setInput] = useState(team?.name ? team?.name : '');
    // const [handle, setHandle] = useState(team?.handle ? team?.handle : '');
    // const [description, setDescription] = useState(team?.description ? team?.description : '');
    const [visibility, setVisibility] = useState<TeamVisibilityType>(
        team?.visibility ? team?.visibility : TeamVisibilityType.PRIVATE,
    );

    const { updateTeam } = useTeamStore();

    const [open, setOpen] = useState(false);

    const { selectedWorkspace: workspace } = useWorkspaceStore();

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 750);
    });

    const { token } = useAntDesignTheme();

    return team?.id && !loading ? (
        <>
            <div style={{ height: '100%' }}>
                <Typography.Title level={4}>Settings</Typography.Title>
                <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                    Manage your team settings.
                </Typography.Paragraph>
                <Divider />
                <Typography.Title level={5}>Name & Visibility</Typography.Title>
                <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                    {/* Change the name and visibility of your team. */}
                    Update the name of your team.
                </Typography.Paragraph>
                <Row wrap={false} gutter={[8, 0]}>
                    <Col flex='auto'>
                        <Input
                            prefix={
                                <TbTextSize
                                    size={'1rem'}
                                    style={{ marginRight: '0.5rem', color: token.colorTextQuaternary }}
                                />
                            }
                            value={input}
                            onChange={(e: any) => {
                                setInput(e.target.value);
                            }}
                            onBlur={() => {
                                const nextTeamName = input.trim();
                                const previousTeamName = team?.name;

                                if (nextTeamName !== previousTeamName && nextTeamName !== '') {
                                    updateTeam(team?.id, { name: nextTeamName }).then(() => {
                                        toast('Team Name Updated', {
                                            description: (
                                                <>
                                                    {previousTeamName}
                                                    <TbArrowRight
                                                        style={{
                                                            verticalAlign: '-0.2rem',
                                                        }}
                                                    />
                                                    {nextTeamName}
                                                </>
                                            ),
                                        });
                                    });
                                }
                            }}
                        />
                    </Col>
                    {/* <Col flex='none'>
                        <Dropdown
                            trigger={['click']}
                            placement='bottomRight'
                            overlay={
                                <Menu
                                    selectedKeys={[visibility]}
                                    onClick={(e: any) => {
                                        try {
                                            authorizedAxiosInstance
                                                .put(`/api/teams/${team?.id}`, { visibility: e.key })
                                                .then((res: AxiosResponse) => {
                                                    if (res.status === 200) {
                                                        setVisibility(e.key);

                                                        toast('Team Visibility Changed', {
                                                            description: (
                                                                <>
                                                                    {team?.visibility}
                                                                    <TbArrowRight
                                                                        style={{
                                                                            verticalAlign: '-0.2rem',
                                                                        }}
                                                                    />
                                                                    {res?.data?.visibility}
                                                                </>
                                                            ),
                                                        });
                                                    }
                                                });
                                        } catch (error) {
                                            captureException(error);
                                        }
                                    }}
                                >
                                    <Menu.Item key={TeamVisibilityType.PRIVATE}>
                                        <TbLock
                                            size='1rem'
                                            style={{
                                                marginRight: '0.375rem',
                                                verticalAlign: '-0.2rem',
                                            }}
                                        />
                                        Private
                                        <br />
                                        <small style={{ color: token.colorTextSecondary }}>
                                            Only members invited to this team can see and join it.
                                        </small>
                                    </Menu.Item>
                                    <Menu.Item key={TeamVisibilityType.WORKSPACE} disabled>
                                        <TbLayoutGrid
                                            size='1rem'
                                            style={{
                                                marginRight: '0.375rem',
                                                verticalAlign: '-0.2rem',
                                            }}
                                        />
                                        Workspace
                                        <br />
                                        <small style={{ color: token.colorTextSecondary }}>
                                            Members within <strong>{workspace?.name}</strong> can see and join this
                                            team.
                                        </small>
                                    </Menu.Item>
                                </Menu>
                            }
                        >
                            <Button block type='dashed' style={{ padding: '0.5rem' }}>
                                <Row style={{ width: '100%' }} wrap={false}>
                                    <Col flex='auto' style={{ textAlign: 'left' }}>
                                        {visibility === 'Private' ? (
                                            <TbLock style={{ verticalAlign: '-0.125rem', marginRight: '0.325rem' }} />
                                        ) : (
                                            <TbLayoutGrid
                                                style={{ verticalAlign: '-0.125rem', marginRight: '0.325rem' }}
                                            />
                                        )}
                                        {visibility}
                                    </Col>
                                    <Col flex='none'>
                                        <TbDirection
                                            style={{
                                                color: token.colorTextTertiary,
                                                verticalAlign: '-0.15rem',
                                                marginLeft: '0.25rem',
                                            }}
                                        />
                                    </Col>
                                </Row>
                            </Button>
                        </Dropdown>
                    </Col> */}
                </Row>
                <Divider />
                <Typography.Title level={5}>Danger Zone</Typography.Title>
                <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                    Delete your team. This action is irreversible.
                </Typography.Paragraph>
                <Button
                    block
                    type='primary'
                    danger
                    icon={<TbUsersMinus size='1.125rem' style={{ verticalAlign: '-0.25rem' }} />}
                    onClick={() => setOpen(true)}
                >
                    Delete Team
                </Button>
                <DeleteTeamModal open={open} setOpen={setOpen} />
            </div>
        </>
    ) : loading ? (
        <BaseSkeleton active round paragraph={{ rows: 14 }} />
    ) : (
        <>error loading</>
    );
};

export default Settings;
